module.exports = __webpack_public_path__ + "static/media/how-it-works-landlord-5.c31874ef.svg";